const ElementorToolbar = ({
  onUndo,
  onRedo,
  onSave,
  onPreview,
  onExportJSON,
  deviceView,
  setDeviceView,
  canUndo,
  canRedo,
}) => {
  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={"Undo"}
            className={`fa-solid fa-rotate-left CP`}
            onClick={onUndo}
            disabled={!canUndo}
          />
          <div className="vr"></div>
          <i
            title={"Redo"}
            className={`fa-solid fa-rotate-right CP`}
            onClick={onRedo}
            disabled={!canRedo}
          />
        </div>
        <div className="hstack">
          <button
            className={`border border-muted rounded-0 py-1 px-3 ${deviceView === "desktop" ? "selectedMenu" : "btn-light"
              }`}
            style={{ fontSize: 13 }}
            onClick={() => setDeviceView("desktop")}
          >
            💻 Desktop
          </button>
          <button
            className={`border border-start-0 border-muted rounded-0 py-1 px-3 ${deviceView === "tablet" ? "selectedMenu" : "btn-light"
              }`}
            style={{ fontSize: 13 }}
            onClick={() => setDeviceView("tablet")}
          >
            📱 Tablet
          </button>
          <button
            className={`border border-start-0 border-muted rounded-0 py-1 px-3 ${deviceView === "mobile" ? "selectedMenu" : "btn-light"
              }`}
            style={{ fontSize: 13 }}
            onClick={() => setDeviceView("mobile")}
          >
            📱 Mobile
          </button>
        </div>
        <div className="hstack gap-2">
          <i
            title="Preview Form"
            className={`fa-solid fa-eye CP`}
            onClick={onPreview}
            style={{ cursor: 'pointer' }}
          />
          <div className="vr"></div>
          <i
            title="Export JSON"
            className={`fa-solid fa-download CP`}
            onClick={onExportJSON}
            style={{ cursor: 'pointer' }}
          />
          <div className="vr"></div>
          <i
            title="Save Form"
            className={`fa-solid fa-floppy-disk CP`}
            onClick={onSave}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
    </>
  );
};

export default ElementorToolbar;
